import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchPurchasingReference, setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { fetchGroups, fetchGroupCategories } from '../../actions/products_actions';
import { printPurchaseReference } from '../../actions/print_actions';
import PurchaseReferenceReport from '../../components/Purchase/purchaseReference';

const purchaseReferenceReport = reduxForm({
  form: 'purchaseReferenceReport',
  destroyOnUnmount: false,
})(PurchaseReferenceReport);

const selector = formValueSelector('purchaseReferenceReport');

function mapStateToProps(state) {
  const typeRadios = selector(state, 'typeRadios');
  return {
    typeRadios,
    groups: state.products.groups,
    purchaseReferenceReportIsLoading: state.purchaseOrders.purchaseReferenceReportIsLoading,
    purchaseReferenceReportError: state.purchaseOrders.purchaseReferenceReportError,
    purchaseReferenceReport: state.purchaseOrders.purchaseReferenceReport,
    groupCategories: state.products.groupCategories,

    requestingPurchaseReferencePdf: state.print.requestingPurchaseReferencePdf,
    purchaseReferencePdf: state.print.purchaseReferencePdf,
  };
}

export default connect(mapStateToProps, {
  fetchGroupCategories,
  fetchGroups,
  fetchPurchasingReference,
  printPurchaseReference,
  setDefaultOfForm,
})(purchaseReferenceReport);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchaseReference.jsx